<template>
  <div>
    <vDevComponent />
    <router-view />
  </div>
</template>

<script>
import vDevComponent from "@/components/devToolsSolutions/index";
import { handleAuth } from "@/service/firebase";

export default {
  components: {
    vDevComponent,
  },
  data() {
    return {
      handleSnapCompra: {},
      handleGeradoToggle: false,
      inativoCount: 0,
      timer: null,
      destruido: false,
    };
  },
  beforeMount() {
    handleAuth();
  },
  mounted() {
    this.verifica_existeCompra();
    window.addEventListener("mousedown", this.resetTimer);
    window.addEventListener("mousemove", this.resetTimer);
    this.verifyInativo();
  },
  beforeDestroy() {
    // Sem isto, cada montagem de /cabine deixava para trás um par de listeners
    // de window e uma cadeia infinita de setTimeout — ambos acumulando e
    // disparando commits no Vuex de componentes já destruídos.
    this.destruido = true;
    clearTimeout(this.timer);
    window.removeEventListener("mousedown", this.resetTimer);
    window.removeEventListener("mousemove", this.resetTimer);
  },
  methods: {
    verifyInativo() {
      if (this.destruido) return;
      this.timer = setTimeout(() => {
        if (this.destruido) return;
        this.inativoCount += 1;
        if (this.inativoCount >= 10) {
          this.$store.commit("totem/setAFK", true);
          this.inativoCount = 10;
        }
        this.verifyInativo();
      }, 2000);
    },
    resetTimer() {
      this.inativoCount = 0;
      this.$store.commit("totem/setAFK", false);
    },
    verifica_existeCompra() {
      if (
        !this.$store.getters["compra/getCompra"].id ||
        this.$store.getters["compra/getCompra"].etapa == "EXPIROU"
      ) {
        this.$root.goto("/cabine/home");
      }
    },
    resetaCompra() {
      setTimeout(() => {
        this.$store.commit("compra/resetCompra");
        this.$router.push("/cabine/home");
        this.handleGeradoToggle = false;
        this.handleSnapCompra();
      });
    },
  },
};
</script>
